import {Grid, Show, VStack} from 'platform/foundation';

import {useGetParticipationQuery} from '@dms/api/core';
import {EntityResourceIds} from '@dms/api/shared';
import {testIds} from '@dms/routes';
import {
  CustomerInformationCard,
  CustomerContactPersonCard,
  Section,
  useCustomerUrl,
  EntityCustomFields,
  useIsLicenceEnabled,
  usePermissions,
  BoschFleetIntegrationCard,
} from '@dms/shared';

import {AddressesCard} from './components/AddressesCard';
import {CommentsCard} from './components/CommentsCard';
import {ContractInformationCard} from './components/ContractInformationCard';
import {NoteCard} from './components/NoteCard';
import {PaymentSettingsCard} from './components/PaymentSettingsCard';

export function CustomerInformation() {
  const {customerId} = useCustomerUrl();

  const {data: customerParticipation} = useGetParticipationQuery({
    recordId: customerId,
    resourceId: EntityResourceIds.customer,
  });

  const [canEditCustomFields, canEditCustomer, canEditContractInformation] = usePermissions({
    permissionKeys: ['customerCustomFields', 'editCustomer', 'editContractInformation'],
    scopes: {
      customerCustomFields: {
        participation: customerParticipation,
        // no branchId on customer
        branchId: 'SKIP',
      },
    },
  });

  const {isWorkshopModuleEnabled, isWarehouseModuleEnabled} = useIsLicenceEnabled();

  return (
    <Section>
      <Grid columns={[1, 2]} spacing={4} align="flex-start">
        <VStack spacing={4}>
          <CustomerInformationCard
            data-testid={testIds.customer.detail('detail')}
            customerId={customerId}
            isEditingDisabled={!canEditCustomer}
          />
          <ContractInformationCard
            data-testid={testIds.customer.detail('detail')}
            customerId={customerId}
            isEditingDisabled={!canEditContractInformation}
          />
          <Show when={isWorkshopModuleEnabled || isWarehouseModuleEnabled}>
            <PaymentSettingsCard
              data-testid={testIds.customer.detail('paymentSettings')}
              customerId={customerId}
            />
          </Show>
          <EntityCustomFields
            recordId={customerId}
            resourceId={EntityResourceIds.customer}
            isEditable={canEditCustomFields}
            data-testid={testIds.customer.detail('customer-custom-fields')}
          />
          <Show when={isWorkshopModuleEnabled}>
            <BoschFleetIntegrationCard customerId={customerId} />
          </Show>
        </VStack>
        <VStack spacing={4}>
          <CustomerContactPersonCard
            data-testid={testIds.customer.detail('detail')}
            customerId={customerId}
            isEditingDisabled={!canEditCustomer}
          />
          <AddressesCard
            data-testid={testIds.customer.detail('detail')}
            customerId={customerId}
            isEditingDisabled={!canEditCustomer}
          />
          <NoteCard data-testid={testIds.customer.detail('detail')} customerId={customerId} />
          <CommentsCard data-testid={testIds.customer.detail('detail')} customerId={customerId} />
        </VStack>
      </Grid>
    </Section>
  );
}
